export default __webpack_public_path__ + "a7a4a0096fda2c2157464cbdc5b12e27.svg";